import Vue from 'vue'
import Vuex from 'vuex'
import { store as ui } from '@/plugins/xtpgui';
import sample from './store';
import auth from './auth';
import crud from './modules/crud';
import api from './modules/api';
import chat from './modules/chat';
import captacaoEmAberto from './modules/operacoes/captacoes/captacaoEmAberto';
import entradaManualCaixa from './modules/tesouraria/entradaManualCaixa';

Vue.use(Vuex)

const state = {}
const getters = {}
const mutations = {}
const actions = {}

const modules = {
    ui,
    sample,
    auth,
    crud,
    api,
    chat,
    captacaoEmAberto,
    entradaManualCaixa
}

export default new Vuex.Store(
  {
    state,
    getters,
    mutations,
    actions,
    modules,
  }
)

